import React from 'react'

function PlayButton() {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="107" height="76" viewBox="0 0 107 76" fill="none">
        <g clip-path="url(#clip0_101_2367)">
          <path d="M104.598 63.0806C104.017 65.718 102.626 68.1102 100.618 69.9254C98.6101 71.7406 96.0843 72.8889 93.391 73.2111C80.1297 75.0557 66.7562 75.9867 53.366 75.9974C39.9766 75.9653 26.6046 75.0344 13.3411 73.2111C10.6477 72.8889 8.12188 71.7406 6.11373 69.9254C4.10559 68.1102 2.71468 65.718 2.13389 63.0806C0.676066 54.8002 -0.0380577 46.407 -2.21574e-05 38.0004C-0.0377705 29.5939 0.676644 21.2006 2.13476 12.9202C2.71555 10.2828 4.10646 7.89066 6.1146 6.07544C8.12275 4.26023 10.6486 3.11192 13.3419 2.78977C26.6032 0.943994 39.9766 0.0118534 53.3669 0C66.7567 0.0214572 80.1294 0.952389 93.3918 2.78631C96.0852 3.10846 98.611 4.25676 100.619 6.07198C102.627 7.88719 104.018 10.2794 104.599 12.9168C106.17 21.1871 106.974 29.5836 107 38.0004C106.838 46.409 106.035 54.7931 104.598 63.0806Z" fill="#FEBB28" />
          <path d="M42.7759 53.4639V21.6465L71.1709 37.5556L42.7759 53.4639Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_101_2367">
            <rect width="107" height="76" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default PlayButton
